<template>
  <div class="d-flex flex-column">
    <div>
      <h6 v-if="label">{{ label }}</h6>
    </div>
    <div>
      <mdb-input
        v-if="search"
        class="m-0"
        size="sm"
        outline
        label="Filter..."
        type="text"
        v-model="searchString"
      />
    </div>
    <div
      ref="wrapper"
      class="flex-grow-1 admin-tab-select-list-wrapper"
    >
      <ul class="list-unstyled admin-tab-select-list">
        <template v-if="nullValueString">
          <li
            :ref="selectedIndex === 0 ? 'active' : null"
            :class="determineActive(0)"
          >
            <div @click="nullOptionSelected()">{{ nullValueString }}</div>
          </li>
          <hr/>
        </template>
        <li
          v-for="(option, index) in filteredOptions"
          :key="index + (nullValueString ? 1 : 0)"
          class="mr-2"
          :style="{position: 'relative'}"
          :ref="selectedIndex === index + (nullValueString ? 1 : 0) ? 'active' : null"
          :class="determineActive(index + (nullValueString ? 1 : 0))"
        >
          <div
            @click="optionSelected(index + (nullValueString ? 1 : 0), true, false)"
          >{{ textCallback(option) }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Bridge8Popover from './Bridge8Popover'
import {mdbInput} from 'mdbvue'
import {comp, equalArrays} from '../utils'

export default {
  name: 'Bridge8SelectList',
  data () {
    return {
      selectedIndex: null,
      searchString: '',
      checkValue: false
    }
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    nullValueString: {
      type: String,
      default: null
    },
    entity: {
      type: String,
      default: null
    },
    textCallback: {
      type: Function,
      default: obj => obj
    },
    search: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    value: {}
  },
  computed: {
    filteredOptions: {
      get () {
        return this.options
          .filter(option => {
            const processed = this.textCallback(option)
            return (![null, undefined].includes(processed) ? processed.toString() : '-- n/a --')
              .toLowerCase().includes(this.searchString.toLowerCase())
          })
          .sort(comp(str => {
            const processed = this.textCallback(str)
            return (![null, undefined].includes(processed) ? processed.toString() : '-- n/a --')
              .toLowerCase()
          }))
      }
    }
  },
  methods: {
    determineActive (index) {
      return this.selectedIndex === index ? 'active' : ''
    },
    nullOptionSelected () {
      this.selectedIndex = 0
      this.$emit('selected', null)
    },
    optionSelected (index, emit = true, holdValue = true) {
      this.selectedIndex = index
      this.checkValue = this.checkValue && holdValue

      const wrapper = this.$refs.wrapper
      const active = wrapper.childNodes[0].childNodes[index]
      if (wrapper && active) {
        const scroll = active.offsetTop - wrapper.offsetTop
        if (scroll < wrapper.scrollTop || scroll > wrapper.scrollTop + wrapper.offsetHeight) {
          wrapper.scrollTop = scroll - wrapper.offsetHeight / 2
        }
      }

      if (emit) {
        const selected = this.filteredOptions[this.selectedIndex - (this.nullValueString ? 1 : 0)] || null
        this.$emit('selected', selected)
      }
    },
    selectByUuid (uuid) {
      const index = this.filteredOptions.findIndex(opt => opt.uuid === uuid)
      this.optionSelected(index >= 0 ? index : null)
    }
  },
  mounted () {
    if (this.entity) {
      this.$bus.$on(`list-select-${this.entity}`, uuid => {
        this.selectByUuid(uuid)
      })
    }
  },
  beforeDestroy: function () {
    this.cargoCreate && this.$bus.$off(`list-select-${this.entity}`)
  },
  watch: {
    filteredOptions: {
      handler (newVal, oldVal) {
        if (!this.checkValue && !equalArrays(newVal, oldVal)) {
          const uuid = (oldVal[this.selectedIndex] && oldVal[this.selectedIndex].uuid) || null
          this.selectByUuid(uuid)
        } else if (!equalArrays(newVal, oldVal)) {
          this.selectedIndex = null
        }
      },
      deep: true
    },
    value (newVal, oldVal) {
      this.checkValue = true
      if (newVal === null) {
        this.optionSelected(null)
      } else {
        const newValProps = Object.getOwnPropertyNames(newVal)
        const searchFun = typeof newVal === 'object' ? opt => {
          const optProps = Object.getOwnPropertyNames(opt)
          if (newValProps.length !== optProps.length) {
            return false
          }
          for (let i = 0; i < newValProps.length; i++) {
            const propName = newValProps[i]
            if (newVal[propName] !== opt[propName]) {
              return false
            }
          }
          return true
        } : opt => opt === newVal
        let index = this.filteredOptions.findIndex(searchFun)
        if (index === -1) {
          this.searchString = ''
          index = this.filteredOptions.findIndex(searchFun)
        }
        this.optionSelected(index, false)
      }
    }
  },
  components: {
    mdbInput,
    Bridge8Popover
  }
}
</script>

<style lang="sass" scoped>
.admin-tab-select-list-wrapper
  overflow-y: scroll
  max-height: 60vh

  .admin-tab-select-list
    li
      font-size: small

      &.active
        font-weight: bold

        & > div
          background-color: adjust_color(darkcyan, $alpha: -0.7)

      & > div
        border-radius: 0.3em
        padding: 0.2em 0.2em 0.2em 0.5em
        cursor: pointer
        text-align: start
        white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/components/Bridge8SelectList.vue